import { render } from "./products.vue?vue&type=template&id=08aa353a&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"

import "./products.vue?vue&type=style&index=0&id=08aa353a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08aa353a"]])

export default __exports__